/**
 * API client bootstrap for the admin app.
 *
 * Imported once from main.tsx so every call to generated SDK functions
 * (e.g. `getHealth`, `login`) uses a single configured client.
 *
 * The admin runs on `careportal.vitabridge.co.kr` and talks to `careapi.vitabridge.co.kr`
 * so we enable `credentials: include` to carry the admin JWT cookie. The
 * client wrapper also echoes the readable XSRF-TOKEN cookie back as
 * `X-XSRF-TOKEN` on mutating requests.
 *
 * Set `VITE_API_BASE_URL` in `.env` / `.env.local`. Defaults to the local
 * Spring Boot dev server on port 8080.
 */
import { configureApiClient } from "@vitacare/api-client";

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") ??
  "http://localhost:8080";

configureApiClient({
  baseUrl: API_BASE_URL,
  withCredentials: true,
});

if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.info(`[api-client] baseUrl=${API_BASE_URL} (credentials: include)`);
}
